module.exports = __webpack_public_path__ + "static/img-woman-choice.c83fecb4.jpg";